import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Form, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import { validation, formValues } from './validationSchema';

import { useDispatch, useSelector } from 'react-redux';
import { addEvidenceList, fetchEvidenceList } from '../../store/actions/evidenceList';

import { errorHelper, Loader } from '../../utils/tools';
import { activityCodeDescriptions } from '../../utils/constants/activityCodes';
import { loadingCodes } from '../../utils/constants/loadingCodes';

import WasteCodeInput from './wasteCodeInput';

const AddEvidenceList = ({onClose}) => {

    const evidences = useSelector(state => state.evidenceList);
    const wasteCodes = useSelector(state => state.wasteCodes.data)
    const currentBranch = useSelector(state => state.branch.current);

    let navigate = useNavigate();

    // Redux logic
    const notifications = useSelector(state => state.notifications);
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: formValues,
        validationSchema: validation,
        // na submit posielame  hodnoty  do funkcie kde nasledne volame funkciu handlesubmit 
        // so vstupnymi parametrami values
        onSubmit: (values) => {
            handleSubmit(values)
        }
    })

    // funkcia handle submit prebera na vstup values z onSubmit 
    const handleSubmit = (values) => {
        if(currentBranch !== '')
            values.branchId = currentBranch;
            dispatch(addEvidenceList(values));
    }

    useEffect(()=>{
        if(notifications && notifications.global.success){
            dispatch(fetchEvidenceList({ branchId: currentBranch }));
            formik.resetForm();
            onClose();
        }
    },[notifications, navigate]);

    return (
        <>
            <div className='auth_container'>
                <h2>Pridať evidenčný list</h2>
                <hr />

                {/* If state users.loading is true showLoader, or show Box */}
                { evidences.loading && wasteCodes.loading ?
                    <Loader/>
                : 
                        <Form
                            component="form"
                            onSubmit={formik.handleSubmit}
                            id="addEvidenceListForm"
                        >

                             {/* Name */}
                             <Form.Group className="mb-3" controlId="formBasicName">
                                <Form.Label>Názov evidenčného listu*</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Zadajte názov evidenčného listu:"
                                    {...formik.getFieldProps('name')}
                                    isInvalid={errorHelper(formik, 'name').error} // Priraď isInvalid na základe error hodnoty z errorHelper
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errorHelper(formik, 'name').helperText} {/* Zobrazenie chybovej správy podľa helperText hodnoty z errorHelper */}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Activity Code */}
                            <Form.Group className="mb-3" controlId="formBasicActivityCode">
                                <Form.Label>Kód činnosti*</Form.Label>
                                <Form.Select
                                    aria-label="Vyberte kód činnosti"
                                    {...formik.getFieldProps('activityCode')}
                                    isInvalid={errorHelper(formik, 'activityCode').error}
                                >

                                    <option value="">Vyberte kód činnosti:</option>
                                    {Object.entries(activityCodeDescriptions).map(([code, description]) => (
                                        <option key={code} value={code}>
                                            {code} - {description}
                                        </option>
                                    ))}
                                    

                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errorHelper(formik, 'activityCode').helperText}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Primary Loading Code - shown only for activity code R */}
                            {formik.values.activityCode === 'R' && (
                                <Form.Group className="mb-3" controlId="formBasicPrimaryLoadingCode">
                                    <Form.Label>Hlavný kód nakladania*</Form.Label>
                                    <Form.Select
                                        aria-label="Vyberte hlavný kód nakladania"
                                        {...formik.getFieldProps('primaryLoadingCode')}
                                        isInvalid={errorHelper(formik, 'primaryLoadingCode').error}
                                    >
                                        <option value="">Vyberte hlavný kód nakladania:</option>
                                        {loadingCodes['Zhodnocovanie odpadu']
                                            .filter(c => !['R12', 'R13'].includes(c.value))
                                            .map(c => (
                                                <option key={c.value} value={c.value}>{c.value} - {c.label}</option>
                                            ))
                                        }
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'primaryLoadingCode').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            )}

                            {/* Waste Code Input */}
                            <WasteCodeInput
                                values={formik.values}
                                setFieldValue={formik.setFieldValue}
                                setFieldTouched={formik.setFieldTouched}
                                touched={formik.touched}
                                errors={formik.errors}
                            />

                            <Row className="mt-3">
                                <hr />
                                <Col className="d-flex justify-content-end">
                                    <Button
                                        className='button-custom-large'
                                        variant='primary'
                                        type="submit"
                                    >
                                        Pridať evidenčný list
                                    </Button>
                                </Col>
                            </Row>

                        </Form>
                }
            </div>
        </>
    )
}

export default AddEvidenceList;